import { createAction } from 'redux-act';

// add Role action
const addRoleRequest = createAction('ADD_ROLE_REQUEST', data => data);
const addRoleSuccess = createAction('ADD_ROLE_SUCCESS', data => data);
const addRoleError = createAction('ADD_ROLE_ERROR');

/* Get All Roles Action */
const getAllRolesRequest = createAction('GET_ALL_ROLES_REQUEST', data => data);
const getAllRolesSuccess = createAction('GET_ALL_ROLES_SUCCESS', data => data);
const getAllRolesError = createAction('GET_ALL_ROLES_ERROR');

/* Get All Roles list Action */
const getAllRolesDataRequest = createAction('GET_ALL_ROLES_DATA_REQUEST', data => data);
const getAllRolesDataSuccess = createAction('GET_ALL_ROLES_DATA_SUCCESS', data => data);
const getAllRolesDataError = createAction('GET_ALL_ROLES_DATA_ERROR');

// Update Role action
const updateRoleRequest = createAction('UPDATE_ROLE_REQUEST', data => data);
const updateRoleSuccess = createAction('UPDATE_ROLE_SUCCESS', data => data);
const updateRoleError = createAction('UPDATE_ROLE_ERROR');

// Delete Role action
const deleteRoleRequest = createAction('Delete_ROLE_REQUEST', data => data);
const deleteRoleSuccess = createAction('Delete_ROLE_SUCCESS', data => data);
const deleteRoleError = createAction('Delete_ROLE_ERROR');

// Assign Role action
const assignRoleRequest = createAction('ASSIGN_ROLE_REQUEST', data => data);
const assignRoleSuccess = createAction('ASSIGN_ROLE_SUCCESS', data => data);
const assignRoleError = createAction('ASSIGN_ROLE_ERROR');

// Get Employees By Role action
const getEmployeesByRoleRequest = createAction('GET_EMPLOYEE_BY_ROLE_REQUEST', data => data);
const getEmployeesByRoleSuccess = createAction('GET_EMPLOYEE_BY_ROLE_SUCCESS', data => data);
const getEmployeesByRoleError = createAction('GET_EMPLOYEE_BY_ROLE_ERROR');

const handleClearRolesStore = createAction('HANDLE_CLEAR_ROLES_STORE', data => data);

export default {
    getAllRolesRequest,
    getAllRolesSuccess,
    getAllRolesError,

    getAllRolesDataRequest,
    getAllRolesDataSuccess,
    getAllRolesDataError,

    addRoleRequest,
    addRoleSuccess,
    addRoleError,

    updateRoleRequest,
    updateRoleSuccess,
    updateRoleError,

    deleteRoleRequest,
    deleteRoleSuccess,
    deleteRoleError,

    assignRoleRequest,
    assignRoleSuccess,
    assignRoleError,

    getEmployeesByRoleRequest,
    getEmployeesByRoleSuccess,
    getEmployeesByRoleError,

    handleClearRolesStore
}